import React, { useEffect, useRef, useState } from "react";
import VehicleDetailsWrapper from "./style";

import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

import Footer from "_shared/Footer/Footer";
import * as utils from "../../helpers/utils";

import { set_active_step, updateLoading } from "redux/actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import { updateLocalDriver, updateVehiclesDetails } from "redux/actions/motorActions";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import SingleVehicle from "./components/SingleVehicle";
import MultipleVehicles from "./components/MultipleVehicles";
import { checkMissingData } from "../../helpers/utils";
import VehiclePreview from "../../../../_shared/VehicleInfoShared/VehiclePreview";
import { VEHICLE_OBJECT } from "application/motor/helpers/models";
import { getDriverDetails } from "services/motorRetailService";
import { Toast } from "primereact/toast";
import {  getVehicleDetails } from "application/motor/services";
import MotorAccord from "application/motor/components/MotorAccord/MotorAccord";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS, isArabic } from "helpers/utils";

const VehicleDetails = (props) => {
  const toast = useRef(null);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const encSerialNumber = params.get("serialNumber");
  const { businessLine } = useParams()

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if(businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF
  else if(businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC
  else if(businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID
  else if(businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB
  else if(businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI

  const policyHolder = useSelector((state) => state.motor.personalFormDetails);
  const vehicles = useSelector((state) => state.motor.vehicles);
  const currentStepIndex = useSelector((state) => state.common.stepper?.activeStep);
  const { tmxVehicleDetails, customerDetails } = useSelector((state) => state.motor);

  const [addAnotherVehicleFlag, setAddAnotherVehicleFlag] = useState(false);
  const [isNextButtonActive, setIsNextButtonActive] = useState(false);
  const [forTagging, setForTagging] = useState(true);

  const [addNewFlag, setAddNewFlag] = useState(false);

  useEffect(() => {
    // for google tagging - when user lands on vehicle details page
    if (!location.state?.lead) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "driverinfo_retrieved",
        ecommerce: {
          funnel_step: "step_4",
          step_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value + "driverinfo_retrieved",
          items: [
            {
              item_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
              item_category: "Motor Insurance",
              item_class: "Individual",
            }
          ]
        }
      });
    }
    dispatch(set_active_step(1));
    window.lmSMTObj.page(location.pathname, {
      path: location.pathname,
      language: isArabic(i18n.language) ? "Arabic" : "English",
      referrer: document.referrer,
      title: document.title,
      url: document.URL,
      search: location.search,
    });
  }, []);

  //  for lead generation
  useEffect(() => {
    if (location.state?.lead) {
      if (Boolean(tmxVehicleDetails?.vehicleDetails?.vehicleDetailsArray?.length)) {
        let localVehicles = [];
        tmxVehicleDetails.vehicleDetails.vehicleDetailsArray.forEach((item) => {
          const vehicleObj = { ...VEHICLE_OBJECT, ...item };
          formik.setFieldValue("values", [getVehicleItemObject()]);
          localVehicles.push(vehicleObj);
        });
        dispatch(updateVehiclesDetails(localVehicles));
      }
    }
  }, [tmxVehicleDetails]);

  useEffect(() => {
    if (policyHolder?.nationalId) {
      getDriverDetails(policyHolder, businessLine)
        .then((response) => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "driverinfo_retrieved",
            item_name: "Motor Insurance New",
            item_category: "Motor Insurance",
            item_class: "Individual",
            funnel_step: "step_4",
            step_name: "motor_policy_new_driverinfo_retrieved",
          });
          dispatch(updateLocalDriver(response));
        })
        .finally((e) => { });
    }
  }, [policyHolder]);

  const getVehicleItemObject = () => {
    const defaults = {
      registrationType: "n",
      vehicleType: "registration",
      number: "",
      yom: "",
      transferId: "",
      usage: "x31",
    }
    return { ...defaults };
  };
  const isTransferOwnership = (rowData) => {
    return rowData.registrationType === "t";
  };
  const isRegistration = (rowData) => {
    return rowData.vehicleType === "registration";
  };
  const formik = useFormik({
    initialValues: {
      type: "s",
      vehicles: [getVehicleItemObject()],
    },
    validate: (data) => {
      let errors = {};
      data?.vehicles?.forEach((item) => {
        if (!item.number) {
          errors["number"] = t("Motor.ThisField");
        }
        if (!isRegistration(item) && !item.yom) {
          errors["yom"] = t("Motor.ThisField");
        }
        if (isTransferOwnership(item) && !item.transferId) {
          errors["transferId"] = t("Motor.ThisField");
        }
      });

      return errors;
    },
    onSubmit: (data) => {
      handleSubmit(data);
    },
  });



  const handleSubmit = async (data) => {
    dispatch(updateLoading(true));

    if (
      vehicles.find(
        (item) =>
          data.vehicles[0].number === item.serialNumber ||
          data.vehicles[0].number === item.customCardNumber
      )
    ) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: i18n.t("Motor.VehicleAlreadyExists"),
        life: 6000,
      });
      dispatch(updateLoading(false));
      return;
    }

    getVehicleDetails(data?.vehicles, businessLine)
      .then((response) => {

        if (response[0] && response[0].resultCode && response[0].resultCode !== "S") {
          return toast.current.show({
            severity: "error",
            summary: "Error",
            detail: response[0].resultMessage,
            life: 6000,
          });
        }
        if (response.length) {
          const Vehicle = { ...VEHICLE_OBJECT, ...response[0] };
          formik.setFieldValue("values", [getVehicleItemObject()]);
          setAddAnotherVehicleFlag(false);
          dispatch(updateLoading(false));
          if (data.vehicles[0].vehicleType === "custom") {
            Vehicle.customCardNumber = data.vehicles[0].number;
          }
          console.log(Vehicle.customCardNumber);
          const vecs = [...vehicles];
          vecs.push(Vehicle);
          dispatch(updateVehiclesDetails([...vecs]));
          if (location.state?.lead) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "carinfo_retrieved",
              ecommerce: {
                funnel_step: "step_5",
                step_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value + "carinfo_retrieved",
                items: [
                  {
                    item_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                    item_category: "Motor Insurance",
                    item_class: "Individual",
                    data_retrieval_method: data?.vehicles[0].vehicleType === "registration" ? "Registration Card" : "Custom Card",
                    is_car_owner: data?.vehicles[0].registrationType === "t" ? "No" : "Yes",
                  }
                ]
              }
            });
          } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "carinfo_retrieved",
              ecommerce: {
                funnel_step: "step_5",
                step_name: "motor_policy_carinfo_retrieved",
                items: [
                  {
                    item_name: "Motor Insurance New",
                    item_category: "Motor Insurance",
                    item_class: "Individual",
                    data_retrieval_method: data?.vehicles[0].vehicleType === "registration" ? "Registration Card" : "Custom Card",
                    is_car_owner: data?.vehicles[0].registrationType === "t" ? "No" : "Yes",
                  }
                ]
              }
            });
          }
          if (addNewFlag) {
            const myVehiclesArr = [...formik.values.vehicles];
            myVehiclesArr.push(getVehicleItemObject());
            formik.setFieldValue("vehicles", myVehiclesArr);
            setAddNewFlag(false);
          }
        } else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            "error_location": "Individual Motor",
            "funnel_step": "step_5",
            "error_messages": response.resultMessage,
          });
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: response.resultMessage,
            life: 6000,
          });
        }
      })
      .catch((e) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          "error_location": "Individual Motor",
          "funnel_step": "step_5",
          "error_messages": JSON.stringify(e),
        });
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: e,
          life: 6000,
        });
      })
      .finally((e) => {
        dispatch(updateLoading(false));
      });
  };

  const nextBtnHandler = () => {
    if (!vehicles.length) {
      formik.handleSubmit();
      return;
    } else {
      // for google tagging - after adding vehicle details
      window.dataLayer = window.dataLayer || [];
      if (!location.state?.lead) {
        window.dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            funnel_step: "step_6",
            step_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.step_name_value + "add_to_cart",
            items: [
              {
                item_name: utils.MotorInsuranceCompaniesDatalayerDictionary[businessLine]?.item_name_value,
                item_category: "Motor Insurance",
                item_class: "Individual",
                num_cars_added: parseFloat(vehicles.length),
                data_retrieval_method: vehicles[0].vehicleType === "registration" ? "Registration Card" : "Custom Card",
              }
            ]
          }
        });
      }
      window.lmSMTObj.track('vehicleDetailsNextClicked', {
        "productName": "Motor",
        "subProductName": "Motor",
        "userName": customerDetails.engFirstName + " " + customerDetails.engLastName,
        "typeOfInsurance": formik?.values?.vehicles[0]?.registrationType === "n" ? "New Insurance" : "Transfer Ownership",
        "vehicles": formik?.values?.vehicles[0]?.registrationType === "n" ? getVehiclesInfo() : ""
      })
      dispatch(set_active_step(currentStepIndex + 1));
      navigate(Boolean(businessLine) ? `/${businessLine}/motor/policy-details` : `/policy-details`, { state: { lead: location.state?.lead, tmx: location.state?.tmx } });
    }
  };

  const getVehiclesInfo = () => {
    let objList = [];
    vehicles.map((vehicle, index) => {
      let obj = {}
      obj["vehicleModel"] = vehicle?.modelName
      obj["model"] = vehicle?.modelCode
      obj["manufactureYear"] = vehicle?.yearOfManufacture
      obj["vehicleValue"] = vehicle?.vehicleValue
      obj["vehicleColor"] = vehicle?.colorName
      obj["cardType"] = formik.values.vehicles[0].vehicleType
      objList.push(obj);
    })
    return objList;

  }

  const canAddMoreDetail = () => {
    return formik.values.vehicles.length < 5;
  };
  const isSelectedType = (code) => {
    return formik.values.type === code;
  };
  const addNewVehicle = () => {
    setAddNewFlag(true);
    formik.submitForm();

    if (forTagging) {
      setForTagging(false);
    }
  };
  const deleteVehicleItem = (index) => {
    const myVehiclesArr = [...formik.values.vehicles].filter((ele, i) => i !== index);
    formik.setFieldValue("vehicles", myVehiclesArr);
  };
  const updateVehicleArray = (data) => {
    formik.setFieldValue("vehicles", [...data]);
  };
  useEffect(() => {
    const isAllValid = vehicles.filter((vehicle) => checkMissingData(vehicle)).length;
    //   // console.log((!!vehicles.length && !isAllValid) || !!Object.keys(formik.errors).length);
    setIsNextButtonActive((!!vehicles.length && !isAllValid) || (!vehicles.length && !Object.keys(formik.errors).length));
  }, [vehicles]);
  const canShowAddForm = () => {
    return addAnotherVehicleFlag || !vehicles.length;
  };
  const addAnotherVehicles = () => {
    formik.resetForm();
    setAddAnotherVehicleFlag(true);
  };

  const backBtnHandler = () => {
    dispatch(set_active_step(currentStepIndex - 1));
    navigate(-1);
  };

  return (
    <VehicleDetailsWrapper businessColor={businessColor} className={`col-md-10 col-xs-12 mx-auto  p-md-4 p-0 ${i18n.language === "ar" ? "ar" : ""}`}>
      <Toast ref={toast} />
      <div className="row p-0">
        <MotorAccord customerDetails={customerDetails} />
      </div>
      <div className="header">{/* <h5>{i18n.t("vehicle-details")}</h5> */}</div>
      {/* <Divider /> */}

      {vehicles?.map((vehicle, index) => {
        if (vehicle.vehicleValue) vehicle.vehicleValue = parseInt(vehicle.vehicleValue.toString()).toString();
        return <VehiclePreview
          key={vehicle.chassisNumber}
          vehicle={vehicle}
          serialNumber={vehicle.serialNumber}
          allowEdit={true}
          hideVehicleValue={true}
          autoSubmit={true}
          opened={true}
          loadProposals={() => { }}
          hideDeduct={true}
          autoNextButton={!!encSerialNumber}
          nextButtonHandler={nextBtnHandler}
          setIsNextButtonActive={setIsNextButtonActive}
        />;
      })}

      {canShowAddForm() && (
        <React.Fragment>
          <form className="p-fluid mt-2 newclassMobileFix">
            {isSelectedType("m") ? (
              <MultipleVehicles
                formik={formik}
                canAddMore={canAddMoreDetail()}
                addNewVehicle={() => addNewVehicle()}
                updateVehicleArray={updateVehicleArray}
                deleteVehicleItem={deleteVehicleItem}
              />
            ) : (
              <SingleVehicle
                formik={formik}
                canAddMore={canAddMoreDetail()}
                addNewVehicle={() => addNewVehicle()}
                deleteVehicleItem={deleteVehicleItem}
                updateVehicleArray={updateVehicleArray}
                setAddAnotherVehicleFlag={setAddAnotherVehicleFlag}
              />
            )}
          </form>
        </React.Fragment>
      )}

      {!canShowAddForm() && !location.state?.lead && (
        <Button
          onClick={() => addAnotherVehicles()}
          label={i18n.t("MotorEn.AddAnother")}
          icon="pi pi-plus"
          className="p-button-sm add-vehicle my-2"
          style={{ background: businessColor }}
        />
      )}
      <div className={`${utils.showMobile() ? "footer-right-mob" : "footer-right"}`}>
        <Footer
          totalPriceSar={i18n.t("RIGHTFOOTER.SAR")}
          showNextBtn={true}
          disableNextBtn={!isNextButtonActive}
          nextBtnHandler={nextBtnHandler}
          nextBtnLabel={i18n.t("RIGHTFOOTER.NEXT")}
          showBackBtn={true}
          backBtnHandler={backBtnHandler}
        />
      </div>
    </VehicleDetailsWrapper>
  );
};

export default VehicleDetails;